// index.ts
import { destination } from "@turf/destination";
import { polygon } from "@turf/helpers";
function circle(center, radius) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var steps = options.steps || 64;
    var properties = options.properties ? options.properties : !Array.isArray(center) && center.type === "Feature" && center.properties ? center.properties : {};
    var coordinates = [];
    for(var i = 0; i < steps; i++){
        coordinates.push(destination(center, radius, i * -360 / steps, options).geometry.coordinates);
    }
    coordinates.push(coordinates[0]);
    return polygon([
        coordinates
    ], properties);
}
var turf_circle_default = circle;
export { circle, turf_circle_default as default }; //# sourceMappingURL=index.js.map
